/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TranslateValue$Plain$Params {
  Content?: string;
  FromLanguage?: string;
  ToLanguage?: string;
}

export function translateValue$Plain(http: HttpClient, rootUrl: string, params?: TranslateValue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, translateValue$Plain.PATH, 'post');
  if (params) {
    rb.query('Content', params.Content, {});
    rb.query('FromLanguage', params.FromLanguage, {});
    rb.query('ToLanguage', params.ToLanguage, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

translateValue$Plain.PATH = '/translate';
